export default __webpack_public_path__ + "img/Inter-BlackItalic_bb94c58.woff2";